module.exports = __webpack_public_path__ + "media/images/athletes/1359-b98492802a3df7cffbeb9198516f7732.png";